import * as React from 'react'
import styles from './style.module.css';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
  import DeliveryMethod from '../../../../../static/IconProvider/delivery_method.svg';
// import { Set_newOrder_draft, Set_Service_DeliveryMethod } from '../../../Redux/actions/actionNames';
// import { INFO_CIRCLE } from '../../../assets';
import clsx from 'clsx';
import IconProvider from '../../../../../design-system/lib/IconProvider';
import Typography from '../../../../../design-system/lib/Typography';
import TooltipOnro from '../../../../../design-system/lib/Tooltip';
import { INFO_CIRCLE } from '../../../../../static';
import { Set_Service_DeliveryMethod } from '../../../../../Redux/actions/actionNames';



function ServicePoint() {
  const { t, i18n } = useTranslation();
  const draft = useSelector((state) => state.NewOrder.newOrder.draft)
  const dispatch = useDispatch();
  const deliveryMethods = useSelector((state) => state.NewOrder.newOrder.service.activeVehicleType?.deliveryMethods )
  const activeDeliveryMethod = useSelector((state) => state.NewOrder.newOrder.deliveryMethod )
  const activeVehicleType = useSelector((state) => state.NewOrder.newOrder.service.activeVehicleType )


    React.useEffect(() => {
      (deliveryMethods && deliveryMethods.length > 0 && !activeDeliveryMethod) &&  dispatch(Set_Service_DeliveryMethod(deliveryMethods[0]))
    }, [activeVehicleType?.id]);

if(!deliveryMethods || deliveryMethods.length <= 1) {
  return null
}

  return (
    <div className={styles.CustomerNewOrderContainer}>
      <div className={styles.customerTitleContainer}>
        <IconProvider Icon={DeliveryMethod} size="16" />
        <Typography weight='Body_Middle_Bold' text={t("DeliveryMethod")} />
      </div>

 

 {deliveryMethods.map((item)=>{
  return <div onClick={()=>{   dispatch(Set_Service_DeliveryMethod(item) ) }} className={clsx(styles.DeliveryMethodContainer , (activeDeliveryMethod && activeDeliveryMethod.id == item.id) && styles.DeliveryMethodContainerActive)}>
        <div className={styles.radioBtn}/>
        <Typography weight='Body_Middle_Medium' style={{color:"hsla(0, 0%, 14%, 1)"}} text={t(item.title)} />
        <TooltipOnro tooltipClassName={styles.TooltipOnro} title={<Typography  style={{padding :"7px 0px"}} weight="Body_Small_Medium" text={item.description} />} placement="right" >
        <img src={INFO_CIRCLE} style={{filter:"grayscale(1)" , width:"12px"}} />
      </TooltipOnro>
    </div>
 })}

    
 

    </div>
  )
}

export default ServicePoint